
  import Header from '../header'
  export default function Boarding() {
    return <div className=' boardingTitle'>
         <div className='colorpage'>
    <Header />
    </div>
 
<div className="container-fluid">
    
 
 <div className="row">
                    <div className="col-lg-6">
                    <img className="titleimageboarding" src="images/shaniandjake.JPG" alt="iphone-mockup" />
                    </div>
                    <div className="col-lg-6">
                    <h1 className="headlines">PMpaws's </h1>
                    <h1 className="boardheadlines">DOG BOARDING </h1>
                        <p className="paragraph">Are you traveling? Planning a short/long trip and you are worried about the safety of your fur baby?   Our attentive team will do their every  possible best to ensure that all pups in out care  feels like a home away from home. Whether you need to board your dog for an overnight stay, for the weekend, a holiday or extended care, your dog will spend their days enjoying supervised open play with other lovely dogs, and their nights enjoying restful sleep.</p>
                        
                        
                       
                    </div>
                </div>

                <div className="row pt-5">
                    <div className="col-lg-6 ">
                    <h1 className="headlines  ">Short / Long term</h1>
                    <h1 className="boardheadlines">DOG BOARDING </h1>
                        <p className="paragraph">Boarding with us will enjoy a stay, burning off any excess energy during a full day of play with our daycare. Dogs are separated into supervised playrooms depending on size,
                         play style and temperament, ensuring the safety of all. They'll enjoy hours of open play that features brain games  that is designed to improve manners and behavior.  There will also be time for naps and breaks, if needed to. If your dog is having lunch, he/she will be fed at the start of naptime and will have plenty of time to digest their food before they are allowed to play again. This private time is also with us at PmPaws, if applicable.</p>

                         <p className="paragraph">We use home-style platform during naptime because we want to give dogs in our care a safe place to rest in, allows them to have some time  for themself and allows the staff to safely dispense individual food, for dogs who eat lunch and/or medication to each dog if applicable. Dogs tend to easily adapt to the naptime routine as it's at the same time each day and all their friends are enjoying the, often much-needed, down time as well! During naptime, the staff also thoroughly cleans each playroom to ensure the room is safe and clean before another exciting round of afternoon play!</p>
                   
                    </div>
                    <div className="col-lg-6 pt-5">
                    <div className="typhography pt-5">
                        <h4 className='typography-text pt-5'>pawsome<sub className="text-danger">Dogs<sup className="text-green">Blog</sup><sub className="text-warning">Canine</sub> <em
                            className="text-warning">Dogs</em>BFF</sub>Care<span className="text-success">Blog<sup
                                className="text-yellow">Spa</sup></span><sub
                                    className="text-warning">Natural</sub><span>Love</span>
                            <sub className="text-danger">Fur</sub><span
                                className="text-wit">Pooch </span>  <sub
                                        className="text-purple">Topknot</sub><span className="text-yellow">Sable</span>
                            <sub><sup>Piebald</sup><span className="text-primary">Specacles</span></sub>
                            <sub>Ticked<sup>Boarding </sup>Care</sub>
                            <sup>Spa</sup><span className="text-tomred">Blog</span><span className="text-green">Natural</span>
                            <sub className="text-red">Natural</sub> <sup className="text-orange">jackass</sup>
                            <span className="text-wit"> pawsome</span> <sub className="text-yellow">Dogs<sup
                                className="text-red">Caveman<sup className="text-blue">Boarding </sup>dweeb</sup>whelp</sub>
                            <span className="text-pink">Nard</span><sub className="text-black">Dogs<sup
                                className="text-green">snoot  <sub className="text-success">Doggo</sub> <em className="text-grey"></em>BFF</sup></sub>
                            <sub className="text-primary">Care</sub><span className="text-green">Tyke</span><span
                                className="text-primary">Mane</span><span className="text-danger">Plume<sup className="text-dark">Mongrel</sup>
                            <span className="text-red">Fido</span>
                            <span className="text-warning">Tyke</span>
                            <sub className="text-dark"><sup className="text-danger"><em className="text-yellow">Dogs</em> whelp</sup></sub>snoot</span>
                            <span className="text-red">shable<sub className="text-black">Wit</sub></span><sup
                                className="text-orange">Blog</sup>BFF

                        </h4>

                    </div>
                    <img className="titleimageboarding" src="images/star.JPG" alt="iphone-mockup" />
                        
                       
                    </div>
                </div>
                <div className="col-lg-12 pt-5">
                    <h1 className="headlines">Prepare your dog for PmPaw's</h1>
                    <h1 className="boardheadlines">BOARDING  REQUIRMENT </h1>
                        <p className="paragraph">Our boarding facilities are fully equipped to handle dogs of all shapes and sizes. We also expect you to provide us the following requirment: </p>
                        <ul>
                            <li>Full health record must be provided</li>
                            <li>Must have taken complete shot and anti rabies.</li>
                            <li>Must be above 5 month</li>
                            <li>Temperament must be communicated</li>
                            <li>Dog name, clear picture and breed required</li>
                        </ul>
                        
                   
                        
                        
                       
                    </div>


                    <div className="row pt-5">
                    <div className="col-lg-6 ">

                    
                    <img className="titleimageboarding" src="images/fac.jpg" alt="iphone-mockup" />
                        
                    <div  >
                    <h3 className='textorg text-green pt-5'> 
                    
                         <strong className='text-secondary'>Home </strong>
                       SWEET HOME.
                       <strong className='text-secondary'> away from</strong>
                       <strong className='text-orange'> HOME.</strong>
                        <strong className='text-secondary'> i can have</strong>
                    <strong className='text-wit'> my own blanket</strong>
                    <strong className='text-orange'> and doggy personal </strong>
                     SPACE

</h3>
<img className="titleimageboarding" src="images/fac.png" alt="iphone-mockup" />

                    </div>
                    </div>
                   
                  
                    <div className="col-lg-6 pt-5">
                    <h1 className="headlines text-secondary">What to</h1>
                    <h1 className="boardheadlines">Bring</h1>
                        <p className="paragraph">We care about your dog's safety and comfort. We encourage you to bring your pup's own food to maintain their regular diet and avoid any digestion issues. You may consider bringing a little extra food for boarding as they burn a lot more calories in play than they typically do at home! If you forget your food for meals no worries! We have in-house food for your convenience.</p>

                         <h1 className='textorg text-tomred pt-5'> 
                    
                    <em className='text-secondary'>Dream </em>
                  BIG
                  <em className='text-secondary'> and  </em>
                  <em className='text-orange'> stay HAPPY </em>
               <em className='text-green'>   ALWAYS</em>   
             

</h1>
<p>During their boarding stay, your dog will be fed at approximately 7 a.m. and 7 p.m., with a treat or lunch at nap time if you request. Food will be served and prepared exactly as requested by each pet parent. We’ll accommodate any special dietary needs your pup may have, and won’t charge extra for feeding or administering medication.</p>
                  <p>You are encouraged to bring any bedding that will make your dog feel “at home” and we will provide it only to them. (Please remember we cannot guarantee bedding will be returned in the same condition.)</p>
                  <p>As your dog will play in an open area with other dogs, we do not accept toys from home. Your dog may feel possessive of their own toys and many are not suitable for the playroom as they are too easily torn or ripped.</p> 
                    </div>
                    </div>
                </div>
                {/* <!-- Footer -->  */}

         
        <footer id="footer bg-success"   >
       <div className='footerPositioning' >
   <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message"> <i className="social-icon fas fa-envelope-square"></i></a>
       <p>© Copyright PmPaws</p>
       </div>
   </footer>
       
 </div>
 
                
    
  }
  
